import { createModel, RematchDispatch } from '@rematch/core';
import { message } from 'antd';
import { createTheme, updateTheme } from '../../../services/theme.service';
import { RootModel } from '../../models';

export const storeName = 'themeModal';

const initialValues = {
  visible: false,
  editTheme: null,
  fetching: false,
};

export const themeModal: any = createModel<RootModel>()({
  state: initialValues, // initial state
  reducers: {
    setVisible(state, payload) {
      return {
        ...state,
        visible: payload,
      };
    },
    setEditTheme(state, payload) {
      return {
        ...state,
        editTheme: payload,
      };
    },
    setFetching(state, payload) {
      return {
        ...state,
        fetching: payload,
      };
    },
  },
  effects: (dispatch: RematchDispatch<typeof themeModal>) => ({
    async saveTheme(payload, state) {
      const { tourTheme } = state.theme;
      this.setFetching(true);
      try {
        let theme;
        const params = { ...payload };
        if (params.id) {
          const { data } = await updateTheme(params);
          theme = data;

          message.success('Update theme successfully');

          if (params.overrides
            && params.overrides.length
            && tourTheme
            && params.overrides.includes(tourTheme.id)
          ) {
            dispatch.theme.setTourTheme({
              ...tourTheme,
              poiIcons: theme.poiIcons
            });
          }
        } else {
          const { data } = await createTheme(params);
          theme = data;
          message.success('Add new theme successfully');
        }
        this.setVisible(false);
        dispatch.theme.filterThemes();
        return theme;
      } catch (err) {
        message.error(`Fail to save theme : ${err.message}`);
        console.error(err.message);
        return null;
      } finally {
        this.setFetching(false);
      }
    },
  }),
});
export default themeModal;
